export default "/dist/files/alertes_vide.782cffe544074ac41ffb4b9b680bd956.svg";